export default __webpack_public_path__ + "static/media/450.59bb8270.jpg";